import { Component, OnInit } from '@angular/core';
import { DwChildConfigBaseComponent, DwMetaDataConfigContext } from '@devwareapps/devware-cap';
import { TimerAutoRefreshConfig } from '../../model/timer-auto-refresh-config.model';

@Component({
  selector: 'app-timer-auto-refresh-action-config',
  template: `
  <div>
    <div dwRow>
      <div dwCol="12">
          <label>Refresh Interval <i class="fa fa-info-circle" title="Determine how often the refresh or refresh check occurs (in seconds)"></i></label>
          <input type="number" class="form-control" [(ngModel)]="config.refreshIntervalSeconds" (ngModelChange)="onChange()">
      </div>
    </div>
    <div dwRow>
      <div dwCol="9">
          <label>Auto Refresh Enabled <i class="fa fa-info-circle" title="Defaults the Auto refresh value"></i></label>
      </div>
      <div dwCol="3">
          <p-inputSwitch [(ngModel)]="config.autoRefreshEnabledDefault" (ngModelChange)="onChange()"></p-inputSwitch>
      </div>
    </div>
    <div dwRow>
      <div dwCol="9">
          <label>Optimize Refresh <i class="fa fa-info-circle" title="Runs a query to get the last modified date/time and refreshes accordindly"></i></label>
      </div>
      <div dwCol="3">
          <p-inputSwitch [(ngModel)]="config.useBackgroundQuery" (ngModelChange)="onChange()"></p-inputSwitch>
      </div>
    </div>
  </div>
  `
})
export class TimerAutoRefreshActionConfigComponent  extends DwChildConfigBaseComponent<TimerAutoRefreshConfig, DwMetaDataConfigContext>  {
  constructor() {
    super();
  }

  getDefaultConfig(): TimerAutoRefreshConfig {
    return {
      refreshIntervalSeconds: 15,
      useBackgroundQuery: true
    };
  }
}
